/**
 * Proveedores Service
 * CRUD para Proveedores (GraphQL)
 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ProveedoresAdminService } from './proveedores-admin.service';
import { ProveedoresAybService } from './proveedores-ayb.service';
import { ProveedoresSourcingService } from './proveedores-sourcing.service';

@Injectable({ providedIn: 'root' })
export class ProveedoresService {
    constructor(
        private proveedoresAdminService: ProveedoresAdminService,
        private proveedoresAybService: ProveedoresAybService,
        private proveedoresSourcingService: ProveedoresSourcingService,
    ) { }

    // PROVEEDOR ADMINISTRATIVO

    /**
     * @description Obtener proveedores (Admin) con nombres, RUC y razón social
     * @param projectionExpression Expresión de proyección
     * @returns Un Observable con la colección de proveedores desde GraphQL Admin.
     */
    getAllAdminWithProjection(projectionExpression?: string): Observable<any[]> {
        return this.proveedoresAdminService.getAllWithProjection(projectionExpression);
    }

    /**
     * @description Obtiene todos los proveedores de admin con nombres.
     * @returns Un Observable con la colección de proveedores desde GraphQL Admin.
     */
    getAllAdminNames(): Observable<any> {
        return this.proveedoresAdminService.getAllWithProjection('id,nombreProveedor');
    }

    /**
     * - Sin uso
     * @description Obtiene todos los proveedores de admin con nombres, RUC y razón social.
     * @returns Un Observable con la colección de proveedores desde GraphQL Admin.
     */
    getAllAdminNamesRazonSocialRUC(): Observable<any> {
        return this.proveedoresAdminService.getAllWithProjection('id,nombreProveedor,razonSocial,numRUC');
    }

    /**
     * @description Obtiene todos los proveedores de admin.
     * @returns Un Observable con la colección de proveedores desde GraphQL Admin.
     */
    getAllAdmin(): Observable<any[]> {
        return this.proveedoresAdminService.getAll();
    }

    /**
     * @description Obtiene todos los proveedores de admin con nombres.
     * @returns Un Observable con la colección de proveedores desde GraphQL Admin.
     */
    getAllAdminSelect(): Observable<any> {
        return this.proveedoresAdminService.getAllWithProjection('id,nombreProveedor');
    }

    /**
     * @description Obtiene un proveedor de admin por su ID.
     * @returns Un Observable con el proveedor de admin correspondiente al ID.
     */
    getAdminById(id: String): Observable<any> {
        return this.proveedoresAdminService.getById(id);
    }

    /**
     * @description Crea un nuevo proveedor de admin.
     * @returns  Un Observable con el resultado de la creación del proveedor de admin.
     */
    createAdmin(provider: any): Observable<any> {
        return this.proveedoresAdminService.create(provider);
    }

    /**
     * @description Actualiza un proveedor existente por su ID.
     * @returns Un Observable con el resultado de la actualización del proveedor.
     */
    updateAdmin(id: any, provider: any): Observable<any> {
        return this.proveedoresAdminService.update(id, provider);
    }

    /**
     * - Sin uso
     * @description Elimina un proveedor por su ID.
     * @returns Un Observable con el resultado de la eliminación del proveedor.
     */
    deleteAdmin(id: any): Observable<any> {
        return this.proveedoresAdminService.delete(id);
    }

    // PROVEEDOR SOURCING

    /**
     * @description Obtener proveedores (Sourcing) con proyección de campos
     * @param projectionExpression Expresión de proyección
     * @param includeDisabled Indica si se deben incluir proveedores deshabilitados
     * @returns Un Observable con la colección de proveedores desde GraphQL Sourcing.
     */
    getAllSourcingWithProjection(projectionExpression?: string, includeDisabled?: boolean): Observable<any[]> {
        return this.proveedoresSourcingService.getAllWithProjectionBySales(projectionExpression, includeDisabled);
    }

    /**
     * @description Obtiene todos los proveedores de sourcing.
     * @returns Un Observable con la colección de proveedores desde GraphQL Sourcing.
     */
    getAllSourcing(): Observable<any[]> {
        return this.proveedoresSourcingService.getAll();
    }

    /**
     * @description Obtiene un proveedor de sourcing por su ID.
     * @param id ID del proveedor de sourcing a obtener
     * @returns Un Observable con el proveedor de sourcing correspondiente al ID.
     */
    getSourcingById(id: String): Observable<any> {
        return this.proveedoresSourcingService.getById(id);
    }

    /**
     * @description Obtiene un proveedor de sourcing por su nombre.
     * @param name Nombre del proveedor de sourcing a obtener
     * @returns Un Observable con el proveedor de sourcing correspondiente al nombre proporcionado
     */
    getSourcingByName(name: String): Observable<any> {
        return this.proveedoresSourcingService.getByName(name);
    }

    /**
     * @description Obtiene todos los proveedores de sourcing con nombres.
     * @returns Un Observable con la colección de proveedores desde GraphQL Sourcing.
    */
    getAllSourcingName(): Observable<any> {
        return this.proveedoresSourcingService.getAllWithProjection('id,nombre');
    }

    // PROVEEDOR SOURCING

    /**
     * @description Obtiene todos los proveedores (A&B) con proyección de campos.
     * @param projectionExpression Expresión de proyección
     * @returns Un Observable con la colección de proveedores desde GraphQL A&B.
     */
    getAllAyBWithProjection(projectionExpression?: string): Observable<any[]> {
        return this.proveedoresAybService.getAllWithProjection(projectionExpression);
    }
}
